import PropTypes from 'prop-types';

const getPageNumbers = (page, totalPages) => {
  const pages = [0];
  // This code calculate the numbers so we can have something like the below.
  // This is following the current page logic in the SilverStripe code as well as possible.
  //
  // Current page is surrounded by '*'
  //
  // *1* 2 3 4 5 6 7 8 9 10
  // *1* 2 3 4 5 6 7 8 9 ... 20
  // 1 2 3 4 *5* 6 7 8 9 ... 20
  // 1 ... 3 4 5 6 *7* 8 9 10 11 ... 20
  // 1 ... 5 6 7 8 *9* 10 11 12 13 ... 20
  // 1 ... 10 11 12 13 *14* 15 16 17 18 ... 20
  // 1 ... 11 12 13 14 15 16 *17* 18 19 20
  // 1 ... 11 12 13 14 15 16 17 18 19 *20*
  const lowest = Math.max(Math.min(Math.max(page - 4, 1), totalPages - 9), 1);
  const highest = Math.min(lowest + 9, totalPages);
  if (lowest > 1) {
    pages.push('...');
  }
  for (let i = lowest; i < highest; i++) {
    pages.push(i);
  }
  if (highest < totalPages) {
    if (highest < totalPages - 1) {
      pages.push('...');
    }
    pages.push(totalPages - 1);
  }
  return pages;
};

/*
 * Shows the Search pagination.
 */
export const SearchPagination = (props) => {
  const { changePage, limit, page, results, searching } = props;
  if (!results || results.totalItems === 0) {
    return null;
  }
  const { totalItems } = results;
  const totalPages = Math.floor((totalItems + limit - 1) / limit);
  const pages = getPageNumbers(page, totalPages);
  if (searching) {
    return <div className="pagination text-center">Loading data from the server...</div>;
  }
  if (pages.length > 1) {
    return (
      <ul className="pagination text-center">
        {page > 0 && (
          <li className="page-item" onClick={changePage(page - 1)}>
            <a className="page-link">«</a>
          </li>
        )}
        {pages.map((pg, index) => {
          if (pg === page) {
            return (
              <li className="page-item active" key={pg}>
                <a className="page-link">{pg + 1}</a>
              </li>
            );
          } else if (!Number.isInteger(pg)) {
            return (
              // Ellipsis entries share the same value; index is acceptable here
              // eslint-disable-next-line @eslint-react/no-array-index-key
              <li className="page-item" key={index}>
                <a className="page-link">{pg}</a>
              </li>
            );
          }
          return (
            <li className="page-item" onClick={changePage(pg)} key={pg}>
              <a className="page-link">{pg + 1}</a>
            </li>
          );
        })}
        {page < totalPages - 1 && (
          <li className="page-item" onClick={changePage(page + 1)}>
            <a className="page-link">»</a>
          </li>
        )}
      </ul>
    );
  }
  return null;
};

SearchPagination.propTypes = {
  changePage: PropTypes.func,
  page: PropTypes.number,
  results: PropTypes.object,
  searching: PropTypes.bool,
};

export default SearchPagination;
